import * as React from 'react'
function SvgPaymentForward(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14 4v4h12V4h4v4h4a2 2 0 012 2v24a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h4V4h4zm18 10H8v18h24V14zm-7.414 3.586l2.828 2.828-8 8c-.39.39-.902.586-1.414.586a1.995 1.995 0 01-1.414-.586l-4-4 2.828-2.828L18 24.172l6.586-6.586z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgPaymentForward
